// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"5285e2b0","498":"694be074","703":"0bcb7f0a"}[chunkId] + ".chunk.js";
};